import { trimStart } from 'lodash';
import { WaffleFlags } from '@/domain/WaffleFlags.enum';

/**
 * Checks if the flag exists in the environment
 * @param waffleFlag {string} - The waffle flag to look for in the env.
 * @returns {*}
 */
const isFlagInEnv = (waffleFlag: WaffleFlags): boolean => {
  if (process.env.VUE_APP_WAFFLE_FLAGS) {
    const waffleFlags = process.env.VUE_APP_WAFFLE_FLAGS.split(',').map((flagString: WaffleFlags) => trimStart(flagString));
    return waffleFlags.includes(waffleFlag);
  }
  return false;
};

const waffleFlagService = (() => {
  let accountWaffleFlags: { accountId: string | null, waffleFlags: Record<WaffleFlags, boolean> | {} } = {
    accountId: null,
    waffleFlags: {}
  };

  return {
    setWaffleFlags(accountId: string | null, waffleFlags: Record<WaffleFlags, boolean>) {
      accountWaffleFlags = {
        accountId,
        waffleFlags
      };
    },
    checkWaffleFlag(waffleFlagName: WaffleFlags): boolean {
      if (process.env.VUE_APP_OVERRIDE_WAFFLE_FLAGS === 'true') return isFlagInEnv(waffleFlagName);
      return !!accountWaffleFlags.waffleFlags[waffleFlagName];
    },
    isOddjobEnabled(): boolean {
      const waffleFlag = WaffleFlags.IsOddjobEnabled;
      return this.checkWaffleFlag(waffleFlag);
    },
    isSurfaceToModelComparisonEnabled(): boolean {
      const waffleFlag = WaffleFlags.IsSurfaceToModelComparisonEnabled;
      return this.checkWaffleFlag(waffleFlag);
    },
    showSurfacelogDeltaHeightLegendConfigurationUi2(): boolean {
      const waffleFlag = WaffleFlags.ShowSurfacelogDeltaHeightLegendConfigurationUi2;
      return this.checkWaffleFlag(waffleFlag);
    },
    showSurfacelogVolumeCalculations(): boolean {
      const waffleFlag = WaffleFlags.ShowSurfacelogVolumeCalculations;
      return this.checkWaffleFlag(waffleFlag);
    }
  };
})();
export default waffleFlagService;